import { Link } from "react-router-dom";
const UserRow = ({ name , title, id }) => {
  return (
    <>
      <tr>
        <td>
            <div>
            </div>
            <div className="my-auto">
              <h6 className="mb-0 text-center">{name }  </h6>
            </div>
        </td>

        <td>
          <span className=" font-weight-bold">{title} </span>
        </td>
       
        <td className="align-middle">

          <Link to={`./${id}`}>

            <button className="btn btn-link text-info mb-0">
            Details
            </button>
          </Link>

        </td>
      </tr>
    </>
  )
}

export default UserRow; 